<template>
  <div class="d-flex flex-wrap">
    <div v-for="operator in firsts_operators" :key="operator.id" class="operator mr-2 mb-2 w-100">
      <poptip trigger="hover" class="poptip ">
        <div slot="content">
          <p class="mb-1">ID: {{ operator.id }}</p>
          <p class="mb-1">{{ $t('autocaller_v2.monitoring.field.login') }}: {{ operator.login }}</p>
          <p class="mb-1">
            {{ $t('autocaller_v2.monitoring.field.status') }}:
            {{ $t(`autocaller_v2.monitoring.operators.state.${operator.state}`) }}
          </p>
        </div>
        <badge-status :state="operator.state" body_class="task--middle">
          <template v-if="operator.login.length > 15">
            {{ `${operator.login.substr(0,15)}...` }}
          </template>
          <template v-else>
            {{ operator.login }}
          </template>
        </badge-status>
      </poptip>
    </div>
    <template v-if="is_collapse">
      <div v-for="operator in lasts_operators" :key="operator.id" class="operator mr-2 mb-2 w-100">
        <poptip trigger="hover" class="poptip ">
          <div slot="content">
            <p class="mb-1">ID: {{ operator.id }}</p>
            <p class="mb-1">{{ $t('autocaller_v2.monitoring.field.login') }}: {{ operator.login }}</p>
            {{ $t(`autocaller_v2.monitoring.operators.state.${operator.state}`) }}
          </div>
          <badge-status :state="operator.state" body_class="task--middle">
            <template v-if="operator.login.length > 15">
              {{ `${operator.login.substr(0,15)}...` }}
            </template>
            <template v-else>
              {{ operator.login }}
            </template>
          </badge-status>
        </poptip>
      </div>
    </template>
    <icon
      v-if="lasts_operators.length"
      :type="!is_collapse ? 'ios-arrow-down' : 'ios-arrow-up'"
      class="callers-collapse__controls-icon col-12"
      @click="is_collapse = !is_collapse"
    />
  </div>
</template>

<script>
  import BadgeStatus from './monitoring-badge-status-operators'
  export default {
    components: {
      BadgeStatus
    },
    props: {
      operators: {
        type: [Array, String],
        default: () => []
      }
    },
    data() {
      return {
        is_collapse: false
      }
    },
    computed: {
      firsts_operators() {
        return this.operators.slice(0,20)
      },
      lasts_operators() {
        return this.operators.slice(20)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .poptip {
    .task{
      width: 141px;
      border-radius: 6px;
    }
  }
  .operator {
    flex: 0 0 140px;
    .ivu-poptip-rel {
      width: 140px;
    }
  }
</style>
